"use strict";
exports.array = Array.isArray;
function primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
exports.primitive = primitive;
//# sourceMappingURL=is.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/snabbdom/is.js
// module id = 81
// module chunks = 0 1 2 3 4 8 9 10 11 12 20 21 22 23 24 25 26 27 28 34 38 39